
import { Objective } from "@models/objective.model"
import { httpRequest } from "../../http"
import { ObjectiveSerializer } from "@models/serializers/objectiveSerializer"

export class CommandGetObjectivesData {
  async run(engagementId: number, objectiveId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/objectives/${objectiveId}/`
    try {
      const response = await httpRequest<any>(url, { method: "GET" })
      console.log('CommandGetObjectivesData response.population_segment ', response.population_segment, ' response ', response);

      return this.deserialize(response)
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }

  deserialize(data: any): Objective {
    const serializer = new ObjectiveSerializer()
    return serializer.deserialize(data)
  }
}

